"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HospitalIcon;
var _react = _interopRequireDefault(require("react"));
var _iconBase = _interopRequireDefault(require("./shared/icon-base"));
var _core = require("@emotion/core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function HospitalIcon(props) {
  return (0, _core.jsx)(_iconBase.default, props, (0, _core.jsx)("path", {
    d: "M11 9H9V7H11V5H13V7H15V9H13V11H11V9ZM22 3H21V23H3V3H2V1H22V3ZM13 21V16H11V21H13ZM19 3H5V21H9V16H7.46436V14H16.5357V16H15V21H19V3H19Z",
    fill: "currentColor"
  }));
}